import React from 'react';
import Graph from './components/Graphs/Graphs';
// import TableEstadisticas from './components/TableEstadisticas';
import { PedidoModification } from '../../Types';
import SummaryDashboard from './components/SummaryDashboard/SummaryDashboard';

interface StatsProps {
    data: PedidoModification[];
    startDate: string;
    endDate: string;
}

const ModificationStats: React.FC<StatsProps> = ({data, startDate, endDate}) => {

    return(
        <div className='pedidos-modifications-stats-container'>
            {/* Summary Cards section - moved from table view */}
                <div className="summary-section">
                    {/* We'll add the SummaryDashboard component here */}
                    <SummaryDashboard 
                        modifications={data}
                        startDate={startDate}
                        endDate={endDate}
                        />
                </div>
            <Graph data={data} />
        </div>
    )

}

export default ModificationStats;